import { useEffect, useRef, useState } from "react";
import CustomButton from "../../../../../components/CustomButton";
import ActionMenu from "../../../../../components/actionMenu/ActionMenu";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../../helpers/apiHelper";
import { postLoadPackageInCar } from "../../../../../redux/api/expedition.api";
import { useAppDispatch } from "../../../../../redux/hooks";
import {
  CargoNodeDataInterface,
  TransportsDataInterface,
} from "../../../../../redux/interfaces/raports.interface";
import ModalWrapper from "../../../../../components/Modal/ModalWrapper";
import Text from "../../../../../styleguide/Text";
import { fetchCargoNode } from "../../../../../redux/api/raports.api";

function CargoNodeActionButtons({
  crudData,
}: {
  itemId: string;
  crudData: CargoNodeDataInterface;
  tableContext: any;
}) {
  const dispatch = useAppDispatch();

  const { id_doctrans_detl, id_doctrans } = crudData;

  const [isLoading, setIsLoading] = useState(false);
  const isSubmitting = useRef(false);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedCar, setSelectedCar] =
    useState<TransportsDataInterface | null>(null);

  useEffect(() => {
    if (isModalOpen) {
      if (crudData.transporturi?.length === 1) {
        setSelectedCar(crudData.transporturi[0]);
      } else {
        setSelectedCar(null);
      }
    }
  }, [isModalOpen, crudData.transporturi]);

  const handleShowModal = () => {
    if (!canLoad || isSubmitting.current) return;
    setIsModalOpen(true);
  };

  const wrongDestination =
    !crudData.sn_bin && crudData.id_nod !== crudData.id_nod_destinatie_colet;
  const canLoad = Boolean(
    crudData.doc_trans &&
      (crudData.transporturi?.length ?? 0) > 0 &&
      !wrongDestination,
  );
  const loadTooltip = wrongDestination
    ? "Coletul are alt nod de destinatie si nu poate fi incarcat aici."
    : !crudData.doc_trans
    ? "Lipseste numarul expeditiei necesar pentru incarcare."
    : !crudData.transporturi?.length
    ? "Nu exista un transport disponibil pentru acest colet."
    : "Alege autovehiculul in care incarci acest colet.";

  const onClose = () => {
    setIsModalOpen(false);
    setSelectedCar(null);
  };

  const isSubmitDisabled =
    !id_doctrans || !id_doctrans_detl || !selectedCar?.id_transport;

  const handleOnSubmit = async () => {
    if (isSubmitDisabled || isSubmitting.current || !selectedCar?.id_transport)
      return;

    isSubmitting.current = true;
    setIsLoading(true);
    try {
      const resultAction = await dispatch(
        postLoadPackageInCar({
          id_doctrans_detl,
          id_transport: selectedCar.id_transport,
          id_doctrans,
        }),
      );

      if (
        checkEndpointStatus(resultAction, postLoadPackageInCar) ===
        endpointStatus.fulfilled
      ) {
        dispatch(
          fetchCargoNode({
            page: 1,
            perPage: 999,
            idNod: crudData.id_nod,
          }),
        );

        onClose();
      }
    } finally {
      isSubmitting.current = false;
      setIsLoading(false);
    }
  };

  return (
    <>
      <ActionMenu
        title={crudData.doc_trans ?? crudData.sn_bin ?? undefined}
        minItemsForMenu={2}
        items={[
          {
            id: "load-package-in-car",
            label: "Incarca in masina",
            icon: "UPLOAD_CARGO",
            tooltip: loadTooltip,
            disabled: !canLoad,
            loading: isLoading,
            onClick: handleShowModal,
          },
        ]}
      />

      <ModalWrapper
        show={!!isModalOpen}
        title={"Incarca coletul in masina"}
        modalSize="sm"
        handleClose={onClose}>
        <div className="flex flex-col">
          <h5 className="mb-3 font-bold text-gray-900">
            Alege masina pentru a incarca coletul:
          </h5>

          <div className="flex flex-wrap gap-2">
            {crudData.transporturi.map((item, idx) => {
              return (
                <button
                  type="button"
                  key={idx}
                  className={`max-w-[100px] cursor-pointer rounded-control border-2 bg-info/10 px-3 py-2 text-info transition ${
                    selectedCar?.id_transport === item.id_transport
                      ? "border-info ring-2 ring-info/10"
                      : "border-slate-200 hover:border-info/40"
                  }`}
                  onClick={() => setSelectedCar(item)}>
                  {item.masina}
                </button>
              );
            })}
          </div>
        </div>

        <CustomButton
          type="submit"
          variant="contained"
          fullWidth
          className="mt-5 w-full"
          disabled={isSubmitDisabled}
          loading={isLoading}
          onClick={handleOnSubmit}>
          <Text variant="body1" isBold>
            Salveaza
          </Text>
        </CustomButton>
      </ModalWrapper>
    </>
  );
}

export default CargoNodeActionButtons;
